import axios from 'apis/axios';
import toast from 'react-hot-toast';
import { logOutUser } from '../redux/user/user.action';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const delay = ms => new Promise(
  resolve => setTimeout(resolve, ms)
);

export const getAllData = async (url, query = {}, fn = ()=>{}) => {
  try{
  const limit = query.limit 
  const page = query.page;
  const response = await axios({
    method: 'GET',
    url,
    params: {
      ...query,
      ...(limit &&{ limit : limit}),
      ...(page && { page : page}),
    },
  });  
  return response.data;
}catch(error){
  toast.error(error?.response?.data?.message ||
    error?.response?.data?.error ||
    JSON.stringify(error?.response?.data) ||
    error?.message ||
    'something went wrong')
  
  await delay(1000);
  
  if(error?.response?.data?.statusCode === "401"){
    localStorage.clear();
    window.location.href="/login"
  }
}
};

export const getAllDataWithoutToast = async (url, query = {}, fn = ()=>{}) => {
  try{
  const limit = query.limit 
  const page = query.page;
  const response = await axios({
    method: 'GET',
    url,
    params: {
      ...query,
      ...(limit &&{ limit : limit}),
      ...(page && { page : page}),
    },
  });  
  return response.data;
}catch(error){
  
  if(error?.response?.data?.statusCode === "401"){
    localStorage.clear();
    window.location.href="/login"
  }
}
};

export const getById = async (url, id) => {
  try{
  const response = await axios({
    method: 'GET',
    url: `${url}/${id}`,
  });
  return response.data;
}catch(error){
  toast.error(error?.response?.data?.message ||
    error?.response?.data?.error ||
    JSON.stringify(error?.response?.data) ||
    error?.message ||
    'something went wrong')
  
  await delay(1000);
  
  if(error?.response?.data?.statusCode === "401"){
    localStorage.clear();
    window.location.href="/login"
  }
  new Error(error);
}
};

export const createDocument = async (url, data) => {
  try {
    const response = await axios({
      method: 'POST',
      url,
      data,
    });

    return response.data;
  } catch(error){
    toast.error(error?.response?.data?.message ||
      error?.response?.data?.error ||
      JSON.stringify(error?.response?.data) ||
      error?.message ||
      'something went wrong')
    
    await delay(1000);
    
    if(error?.response?.data?.statusCode === "401"){
      localStorage.clear();
      window.location.href="/login"
    }
    new Error(error);

  }
};

export const updateDocumentByID = async (url, id, data) => {
  try {
    const response = await axios({
      method: 'PUT',
      url: `${url}/${id}`,
      data,
    });
    return response.data;
  } catch(error){
    toast.error(error?.response?.data?.message ||
      error?.response?.data?.error ||
      JSON.stringify(error?.response?.data) ||
      error?.message ||
      'something went wrong')
    
    await delay(1000);
    
    if(error?.response?.data?.statusCode === "401"){
      localStorage.clear();
      window.location.href="/login"
    }
    new Error(error);

  }
};

export const deleteDocumentById = async (url, id) => {
  try {
    const response = await axios({
      method: 'DELETE',
      url: `${url}/${id}`,
    });
    return response.data;
  }catch(error){
    toast.error(error?.response?.data?.message ||
      error?.response?.data?.error ||
      JSON.stringify(error?.response?.data) ||
      error?.message ||
      'something went wrong')
    
    await delay(1000);
    
    if(error?.response?.data?.statusCode === "401"){
      localStorage.clear();
      window.location.href="/login"
    }
    new Error(error);

  }
};
